import NavLinks from "./Navlinks";
import "../Css/Navbar.css";

const Navigation = () => {
  return (
    <div className="navbar main-nav">
      <NavLinks />
    </div>
  );
};

export default Navigation;
